"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcAuthentication = void 0;
const react_1 = require("react");
const authentication_provider_1 = require("./components/authentication-provider");
// eslint-disable-next-line require-jsdoc
function useOidcAuthentication() {
    const context = react_1.useContext(authentication_provider_1.AuthenticationContext);
    if (!context) {
        throw new Error('useOidcAuthentication must be used within a AuthenticationProvider');
    }
    return context;
}
exports.useOidcAuthentication = useOidcAuthentication;
//# sourceMappingURL=use-authentication.js.map